import { useEffect, useRef } from 'react'
import { connect } from 'react-redux'
import { fetchMetadata, fetchHiringTeams, switchHiringTeam, signOut } from '../../reducks/sessions'
import { userRole, emailPreferencesAccessTokenKey, currentUser } from '../../selectors/currentUser'
import { urlPath } from '../../selectors/router'
import { sessionMetadata, currentHiringTeam, hiringTeamsList } from '../../selectors/sessions'

const CurrentUser = ({
  reduxDispatchFetchSessionMetadata,
  reduxDispatchFetchHiringTeams,
  reduxDispatchSwitchHiringTeam,
  pathname,
  children,
  ...props
}) => {
  const prevPathname = useRef(pathname)

  useEffect(() => {
    reduxDispatchFetchSessionMetadata()
    reduxDispatchFetchHiringTeams()
  }, [reduxDispatchFetchSessionMetadata, reduxDispatchFetchHiringTeams])

  useEffect(() => {
    if (prevPathname.current !== pathname) {
      reduxDispatchFetchSessionMetadata()
    }
    prevPathname.current = pathname
  }, [pathname, reduxDispatchFetchSessionMetadata])

  return children({
    switchHiringTeam: (companySlug, id) => reduxDispatchSwitchHiringTeam(companySlug, { current_hiring_team_id: id }),
    ...props,
  })
}

const mapStateToProps = state => ({
  pathname: urlPath(state),
  userRole: userRole(state),
  metadata: sessionMetadata(state),
  currentHiringTeam: currentHiringTeam(state),
  hiringTeams: hiringTeamsList(state),
  emailPreferencesAccessTokenKey: emailPreferencesAccessTokenKey(state),
  category: currentUser(state).category,
  hubspotUrl: currentUser(state).hubspotUrl,
  email: currentUser(state).email,
  isReviewer: currentUser(state).isReviewer,
  isAccountManager: currentUser(state).isAccountManager,
  isOfferzen: currentUser(state).isOfferzen,
})

const mapDispatchToProps = {
  reduxDispatchFetchSessionMetadata: fetchMetadata,
  reduxDispatchFetchHiringTeams: fetchHiringTeams,
  reduxDispatchSwitchHiringTeam: switchHiringTeam,
  signOut,
}

export default connect(mapStateToProps, mapDispatchToProps)(CurrentUser)
